import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { AcceptedQueryTypes } from '@commercetools/frontend-sdk/lib/types/Query';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import {
  DownloadInvoicePdfActionReturn,
  GetInvoicesTabActionReturn,
  GetInvoicesTabQuery,
  GetInvoiceTotalsActionReturn,
  GetInvoiceTotalsQuery,
  InvoiceActions,
} from '../../types/actions/InvoiceActions';

export type { InvoiceActions };

export const getInvoiceActions = (sdk: SDK<ComposableCommerceEventsB2B>): InvoiceActions => ({
  getInvoicesTab: async (
    query?: GetInvoicesTabQuery,
    options: {
      parallel?: boolean;
      customHeaderValue?: string;
      serverOptions?: ServerOptions;
    } = {},
  ) => {
    const response = await sdk.callAction<GetInvoicesTabActionReturn>({
      actionName: 'invoices/getInvoicesTab',
      query: query as AcceptedQueryTypes | undefined,
      parallel: options.parallel,
      customHeaderValue: options.customHeaderValue,
      serverOptions: options.serverOptions,
    });
    return response;
  },

  getInvoiceTotals: async (
    query?: GetInvoiceTotalsQuery,
    options: {
      parallel?: boolean;
      customHeaderValue?: string;
      serverOptions?: ServerOptions;
    } = {},
  ) => {
    const response = await sdk.callAction<GetInvoiceTotalsActionReturn>({
      actionName: 'invoices/getInvoiceTotals',
      query: query as AcceptedQueryTypes | undefined,
      parallel: options.parallel,
      customHeaderValue: options.customHeaderValue,
      serverOptions: options.serverOptions,
    });
    return response;
  },

  downloadInvoicePdf: async (invoiceReference: string, options = {}) => {
    const response = await sdk.callAction<DownloadInvoicePdfActionReturn>({
      actionName: 'invoices/downloadInvoicePdf',
      query: { invoiceReference },
      serverOptions: options.serverOptions,
    });
    return response;
  },
});
